import logCloudWatchEvent from '../services/cloudWatchLogging';

/**
 * True only for the `local` environment (a developer's machine). Deployed
 * environments — `development`, `qa`, `prod` — are false, so they log to CloudWatch.
 */
export function isLocalDev(): boolean {
  return process.env.REACT_APP_ENVIRONMENT?.toLowerCase() === 'local';
}

/**
 * Routes an error report to the right sink: the browser **console** when running
 * locally (`REACT_APP_ENVIRONMENT=local`), **CloudWatch** when deployed. Never throws.
 */
export function reportError(logGroup: string, logStream: string, details: unknown): void {
  if (isLocalDev()) {
    console.error(`[error] ${logGroup} / ${logStream}`, details);
    return;
  }
  logCloudWatchEvent(logGroup, logStream, JSON.stringify({ details })).catch(() => undefined);
}
